import { Form } from "antd";
import React, { FC } from "react";
import { ProductOrderItem } from "tm-shared/types";

import { useInfiniteScroll } from "@/hooks";
import { StrictRejectProduct } from "@/pages/WorkPlan/Tasks/RejectProducts/RejectProducts.types";
import { PrimaryText } from "@/shared/ui/Typography";

import { RejectProductCard } from "../RejectProductCard";

interface RejectProductsListProps {
    products: StrictRejectProduct[];
    taskId: string;
    hasProducts: boolean;
    rejectProductsList: {
        [barcode: string]: ProductOrderItem;
    };
}

export const RejectProductsList: FC<RejectProductsListProps> = ({
    products,
    taskId,
    rejectProductsList,
    hasProducts,
}) => {
    const { visibleItems, loadMore } = useInfiniteScroll(products);

    return (
        <>
            {hasProducts ? (
                <>
                    <Form>
                        {visibleItems.map((item, i, arr) => (
                            <RejectProductCard
                                key={item.barcode}
                                barcode={item.barcode}
                                name={item.name}
                                itemsLeft={item.max}
                                taskId={taskId}
                                rejectProductsCounter={
                                    rejectProductsList?.[item.barcode]?.count
                                }
                                price={item.price}
                                isLast={i === arr.length - 1}
                                onView={loadMore}
                            />
                        ))}
                    </Form>
                </>
            ) : (
                <PrimaryText style={{ textAlign: "center" }} fontSize={16}>
                    Немає товарів для повернення
                </PrimaryText>
            )}
        </>
    );
};
